export function resolveDefaultLanding({ isAdmin, role, managerHome }) {
  if (isAdmin) return "admin";
  if (role === "manager" && managerHome !== "legacy_metrics") return "engagement";
  return "advisor_workspace";
}
